/* tslint:disable */
/* eslint-disable */
/**
 * Jobs 24/7
 * Jobs 24/7
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: shraaliya0802@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddCategoryRequest
 */
export interface AddCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof AddCategoryRequest
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof AddCategoryRequest
     */
    domainId?: number;
}

/**
 * Check if a given object implements the AddCategoryRequest interface.
 */
export function instanceOfAddCategoryRequest(value: object): value is AddCategoryRequest {
    return true;
}

export function AddCategoryRequestFromJSON(json: any): AddCategoryRequest {
    return AddCategoryRequestFromJSONTyped(json, false);
}

export function AddCategoryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddCategoryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'domainId': json['domainId'] == null ? undefined : json['domainId'],
    };
}

  export function AddCategoryRequestToJSON(json: any): AddCategoryRequest {
      return AddCategoryRequestToJSONTyped(json, false);
  }

  export function AddCategoryRequestToJSONTyped(value?: AddCategoryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'domainId': value['domainId'],
    };
}

